import '@fontsource/ibm-plex-sans/400.css';
import '@fontsource/ibm-plex-sans/500.css';
import '@fontsource/ibm-plex-sans/600.css';
import '@fontsource/playfair-display/500.css';
import '@fontsource/playfair-display/600.css';
import '@fontsource/playfair-display/500-italic.css';
import 'virtual:tokens.css';
import './styles.css';

import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import { QueryClient } from '@tanstack/react-query';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Toaster } from 'sonner';
import { ErrorApi } from './api/cliente';
import './api/offline/cola';
import { SesionProvider } from './api/sesion';
import { router } from './router';

const DIA_MS = 24 * 60 * 60 * 1000;
/** Consultas que no vale la pena guardar (búsquedas, descargas, reportes pesados). */
const NO_PERSISTIR = new Set(['buscar', 'reporte', 'notificaciones']);

const persister = createSyncStoragePersister({ storage: window.localStorage, key: 'bb-cache', throttleTime: 2000 });

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      // Se conservan un día para poder consultar agenda y clientes sin conexión.
      gcTime: DIA_MS,
      refetchOnWindowFocus: true,
      // No reintentar errores de negocio o permisos; sí fallas de red.
      retry: (intentos, error) => !(error instanceof ErrorApi && error.status < 500) && intentos < 2,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{
        persister,
        maxAge: DIA_MS,
        buster: import.meta.env.VITE_VERSION ?? 'dev',
        dehydrateOptions: {
          shouldDehydrateQuery: (q) => q.state.status === 'success' && !NO_PERSISTIR.has(String(q.queryKey[0])),
        },
      }}
    >
      <SesionProvider>
        <RouterProvider router={router} />
        <Toaster
          position="bottom-right"
          toastOptions={{ className: 'font-sans border border-border bg-surface text-foreground' }}
          closeButton
        />
      </SesionProvider>
    </PersistQueryClientProvider>
  </StrictMode>,
);
